import { useQuery } from '@apollo/client';
import { useEntity } from '@avangard/utils/entity';

import { StudentOnlineApplicationEntity } from '@modules/students/entities';
import { GetStudentOnlineApplicationShortQuery } from '@modules/students/graphql';

import type { QueryHookOptions } from '@apollo/client';
import type {
    GetStudentOnlineApplicationShortQueryType,
    GetStudentOnlineApplicationShortQueryVariables,
} from '@modules/types/graphql';

const useStudentOnlineApplicationShort = (
    options: QueryHookOptions<
        GetStudentOnlineApplicationShortQueryType,
        GetStudentOnlineApplicationShortQueryVariables
    > = {},
) => {
    const queryResult = useQuery<
        GetStudentOnlineApplicationShortQueryType,
        GetStudentOnlineApplicationShortQueryVariables
    >(GetStudentOnlineApplicationShortQuery, options);

    const studentOnlineApplication = useEntity(
        () =>
            new StudentOnlineApplicationEntity(
                queryResult.data?.getStudentOnlineApplication ?? null,
            ),
        [queryResult.data],
    );

    const result = {
        studentOnlineApplication,
        ...queryResult,
    };

    return result;
};

export { useStudentOnlineApplicationShort };
